import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { GuidInfo } from './../../../_model/common/guid-info.model';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {
    public version: string = environment.VERSION;

    @Input()
    public guidData: GuidInfo;

    constructor() {}

    ngOnInit() {}
}
